<div class="bulletin-board">
  <div class="title-container">
    <span class="title">Bulletin Board</span>
  </div>
  <div class="content">
    <div class="top-section">
      <app-new-button
        leftIcon="arrow_back"
        size="sm"
        (clickHandler)="goBack()"
        color="bare"
      >Back</app-new-button>
      <span class="top-section-title">Edit Post</span>
    </div>
    <app-loading-spinner *ngIf="isLoading"></app-loading-spinner>
    <div *ngIf="!isLoading" class="bottom-section">
      <div class="subtitle-container">
        <span class="subtitle">Title & Content</span>
      </div>
      <div class="post-content-container">
        <div class="post-title-field-container">
          <span class="post-title-field-label">Post Title (required)</span>
          <input [(ngModel)]="post.title" class="post-title-field-value" />
        </div>
        <editor
          [apiKey]="tinyMceKey"
          licenseKey="'gpl'"
          [(ngModel)]="post.content"
          width="'100%'"
          [init]="{
            menubar: 'false',
            inline: false,
            plugins: 'autoresize lists link image paste help wordcount',
            toolbar: 'undo redo | bold italic underline | alignleft aligncenter alignright alignjustify'
          }"
        ></editor>
      </div>
    </div>
    <div *ngIf="!isLoading" class="buttons-container">
      <app-new-button
        size="sm"
        (clickHandler)="deletePost()"
        color="red"
      >Delete Post</app-new-button>
      <div class="right-side-buttons">
        <app-new-button
          size="sm"
          (clickHandler)="goBack()"
          color="bare"
        >Cancel & Exit</app-new-button>
        <app-new-button
          size="sm"
          (clickHandler)="updatePost()"
          color="green"
        >Update Post</app-new-button>
      </div>
    </div>
  </div>
</div>
